module.exports = __webpack_public_path__ + "img/icon_menu_close.b195aff8.svg";